/* eslint-disable no-undef */
import './polyfills' // should be first
import '../styles/index.scss'
import './initIntegrations'

import { combineReducers } from 'redux'
import ReduxThunk from 'redux-thunk'
import { configureStore as cS } from '@reduxjs/toolkit'
import { connectRouter, routerMiddleware } from 'connected-react-router'
import { createEpicMiddleware, combineEpics } from 'redux-observable'

// Sentry
import * as Sentry from '@sentry/react'

import { middleware as cacheMiddleware } from './cache'
import { reducers, epics } from './store'
import { reducer as resource, epic as resourceEpic } from './common/utils/resource'
import dashboardReducer from './store/reducers/dashboard/dashboardSlice'
import conversationReducer from './store/reducers/conversation/conversationSlice'
import orderReducer from './store/reducers/order/orderSlice'
import userReducer from './store/reducers/user/reviewerQueuesSlice'
import usersReducer from './store/reducers/user/usersSlice'
import inspectionReducer from './store/reducers/inspection/inspectionSlice'
import contactProfilesReducer from './store/reducers/contactProfile/contactProfileSlice'
import integrationLogsReducer from './store/reducers/integrationLogs/integrationLogsSlice'
import orderFiltersReducer from './store/reducers/orderFilters/orderFiltersSlice'
import notificationReducer from './store/reducers/notifications/notificationsSlice'
import submissionReviewsReducer from './store/reducers/submissionReviews/submissionReviewsSlice'
import submissionFilesReducer from './store/reducers/submissionFiles/submissionFilesSlice'
import orderReviewsReducer from './store/reducers/orderReviews/orderReviewsSlice'
import vendorScoreReducer from './store/reducers/vendorScore/vendorScoreSlice'
import panelistReducer from './store/reducers/panelist/panelistSlice'
import lenderReducer from './store/reducers/lender/lenderSlice'
import productReducer from './store/reducers/product/productSlice'
import feeManagementReducer from './store/reducers/feeManagement/feeManagementSlice'
import loanOverridesReducer from './store/reducers/loanOverrides/loanOverridesSlice'
import underwritersReducer from './store/reducers/underwriters/underwritersSlice'
import API from './api'

const createHistory = require('history').createBrowserHistory
const history = createHistory()

const configureStore = (initialState) => {
  const middleware = [
    ReduxThunk,
    createEpicMiddleware(combineEpics(...epics, resourceEpic), {
      dependencies: { API },
    }),
    routerMiddleware(history),
    cacheMiddleware,
  ]
  const sentryReduxEnhancer = Sentry.createReduxEnhancer()

  const allReducers = combineReducers({
    router: connectRouter(history),
    resource,
    ...reducers,
    dashboard: dashboardReducer,
    conversation: conversationReducer,
    order: orderReducer,
    reviewerQueues: userReducer,
    inspections: inspectionReducer,
    contactProfiles: contactProfilesReducer,
    integrationLogs: integrationLogsReducer,
    orderFilters: orderFiltersReducer,
    notifications: notificationReducer,
    submissionReviews: submissionReviewsReducer,
    submissionFiles: submissionFilesReducer,
    orderReviews: orderReviewsReducer,
    vendorScore: vendorScoreReducer,
    panelist: panelistReducer,
    users: usersReducer,
    lender: lenderReducer,
    product: productReducer,
    feeManagement: feeManagementReducer,
    loanOverrides: loanOverridesReducer,
    underwriters: underwritersReducer,
  })

  const createStore = (initialState) => {
    return cS(
      {
        reducer: allReducers,
        preloadedState: initialState,
        middleware: middleware,
      },
      sentryReduxEnhancer,
    )
  }

  return createStore(initialState)
}

export { history, configureStore }
